export default __webpack_public_path__ + "static/media/marek-szturc-CM1oVEUzsNM-unsplash.591094e2.jpg";